import { useEffect } from 'react';
import PropTypes from 'prop-types';
import AbstractContainer from '../abstracts/abstractContainer';
import ArticleAuthors from '../articleAuthors/articleAuthors';
import ArticlePublicationInfo from '../articlePublicationInfo/articlePublicationInfo';
import ArticleTitle from '../articleTitle/articleTitle';
import DoiArticlePreviewActions from './actions/doiArticlePreviewActions';
import PiiArticlePreviewActions from './actions/piiArticlePreviewActions';
import PanelHeader from '../sidebar/panelHeader/panelHeader';
import { ArticleEventsPropTypes } from '../../utils/trackers/createArticleEvents';
import { trackAdobeEvent } from '../../utils/trackers/adobe';

const ArticlePreview = ({
  authors,
  doi,
  eid,
  eventData,
  onComponentClick,
  pageRange,
  pdfPath,
  pii,
  publicationDate,
  publicationName,
  title,
}) => {
  const {
    previewContentView,
    savePdf,
    titleClick,
    viewAtPublisher,
    viewPdf,
  } = eventData;

  useEffect(() => {
    if (previewContentView) {
      trackAdobeEvent('contentView', previewContentView);
    }
  }, [previewContentView]);

  return (
    <div className="article-preview-panel sidebar-scroll-panel sidebar-panel-default-appearance">
      <PanelHeader title="Article preview" />

      <div className="sidebar-scroll-panel-body">
        <div className="u-margin-s-bottom text-l u-font-serif">
          <ArticleTitle
            title={title}
            doi={doi}
            pii={pii}
            titleClickEventData={titleClick}
            onClick={onComponentClick}
          />
        </div>

        <div className="article-preview-panel-authors text-xs">
          <ArticleAuthors authors={authors} />
        </div>

        <ArticlePublicationInfo
          pageRange={pageRange}
          publicationDate={publicationDate}
          publicationName={publicationName}
        />

        {pii && (
          <PiiArticlePreviewActions
            pii={pii}
            pdfPath={pdfPath}
            viewPdfEventData={viewPdf}
            savePdfEventData={savePdf}
            onComponentClick={onComponentClick}
          />
        )}
        {
          !pii && doi
          && (
            <DoiArticlePreviewActions
              doi={doi}
              viewAtPublisherEventData={viewAtPublisher}
            />
          )}

        <AbstractContainer pii={pii} doi={doi} scopusEid={eid} />
      </div>
    </div>
  );
};

ArticlePreview.propTypes = {
  authors: PropTypes.arrayOf(PropTypes.string).isRequired,
  doi: PropTypes.string,
  eid: PropTypes.string,
  eventData: ArticleEventsPropTypes,
  onComponentClick: PropTypes.func,
  pageRange: PropTypes.arrayOf(PropTypes.string),
  pdfPath: PropTypes.string,
  pii: PropTypes.string,
  publicationDate: PropTypes.string,
  publicationName: PropTypes.string,
  title: PropTypes.node.isRequired,
};

ArticlePreview.defaultProps = {
  doi: undefined,
  eid: undefined,
  eventData: {},
  onComponentClick: undefined,
  pageRange: [],
  pdfPath: undefined,
  pii: undefined,
  publicationDate: undefined,
  publicationName: undefined,
};

export default ArticlePreview;
